import React from 'react'
import { defPath } from '../../config/defPath'
import gsap from "gsap";
import { useCamerino } from '../../hooks/useState';

interface PropsDressingRoom {
    closeMenu: () => void
}

const CustomizePlayer: React.FC<PropsDressingRoom> = ({ closeMenu }) => {
    const { setCategory } = useCamerino(state => state)

    const handleClick = (e: any, category: any) => {
        // @ts-ignore
        window.soundController && window.soundController.play('camerino_first', false, 1)
        setCategory(category)
        closeMenu()
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${e.target.textContent} - Customize Avatar`,
            'interaction': 'true',
            'component_name': 'Modo_Carrera_AvatarMenu',
            'element_text': 'Personalización Avatar',
        });
    }

    return (
        <div className='customizePlayer'>
            <div className="customizePlayer__body">
                <div className="customizePlayer__left">
                    <nav className="navCustomizer">
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn" onClick={(e) => handleClick(e, 'accesorios')}>
                                <div className="img">
                                    <img src={`${defPath}/assets/images/customizePlayer/iconGlasses.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'>Accesorios</h3>
                                </div>
                            </div>
                        </a>
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn" onClick={(e) => handleClick(e, 'calzado')}>
                                <div className="img">
                                    <img src={`${defPath}/assets/images/customizePlayer/iconShoes.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'>Calzado</h3>
                                </div>
                            </div>
                        </a>
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn active" onClick={(e) => handleClick(e, 'canjeables')}>
                                <div className="img img-money">
                                    <img src={`${defPath}/assets/images/customizePlayer/money.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'>Canjear</h3>
                                    <p className='black_30'>Monedas</p>
                                </div>
                            </div>
                        </a>
                    </nav>
                </div>
                <div className="customizePlayer__right">
                    <nav className="navCustomizer">
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn" onClick={(e) => handleClick(e, 'estilos')}>
                                <div className="img">
                                    <img src={`${defPath}/assets/images/customizePlayer/iconStyle.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'>Estilo</h3>
                                </div>
                            </div>
                        </a>
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn" onClick={(e) => handleClick(e, 'up')}>
                                <div className="img">
                                    <img src={`${defPath}/assets/images/customizePlayer/iconShirt.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'><span className='black_20'>Parte</span>Superior</h3>
                                </div>
                            </div>
                        </a>
                        <a className="navCustomizer__container">
                            <div className="navCustomizer__btn" onClick={(e) => handleClick(e, 'down')}>
                                <div className="img">
                                    <img src={`${defPath}/assets/images/customizePlayer/iconPants.png`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className='black_30'><span className='black_20'>Parte</span>Inferior</h3>
                                </div>
                            </div>
                        </a>
                    </nav>
                </div>
            </div>
            <a href="/estadio-aguila" className="ar__btn-primary ar__btn--volver">ir al estadio</a>
        </div>
    )
}

export default CustomizePlayer